import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle } from 'reactstrap';
import { Link } from 'react-router-dom';
import book1 from '../media/book1.jpg';
import bookAbove991 from '../media/mapleinfobook.jpg';
import nutritionBG from '../media/maplestorageandnutritionalinfopagebackground.jpg';


export default class Storage extends Component {
  //static propTypes = {testProp: PropTypes.bool.isRequired}

  constructor(props) {
    super(props);

    this.state = {

    };
  }

  render() {
    //const ExampleObject = ( <div></div> );

    return (
    	<FluidContainer fluid>
        <Helmet>
          <title>Storage Tips - Patterson Maple Farms</title>
        </Helmet>
        <InternalContainer>
      		<h1>Maple Storage Tips & Tricks</h1>

          <BookImgsRow>
            <BookImgCol1 xs="12" lg="6">
              <SingleBookBgDiv>
                <h3>Maple Storage Information</h3>
                <p>Once syrup is opened, refrigeration will help maintain freshness. <br /> <br />
                   Store maple syrup in your freezer to retain flavor and quality over an indefinite period of time.
                   The syrup will not freeze solid. About one hour at room temperature to bring it to pouring consistency.
                   The amount desired can be removed from the container, and then the remainder may be returned to the freezer.
                   After extended storage, if mold forms on the surface of the syrup, the original quality can be restored. 
                   Simply remove the mold, heat the syrup to a boil, skim the surface, sterilize the container, and refill the
                   container with the syrup.

                   </p>
              </SingleBookBgDiv>
            </BookImgCol1>

            <BookImgCol2 xs="12" lg="6">
              <SingleBookBgDivTwo>
                <img src={require("../media/storageRightPic.jpg")}></img>
              </SingleBookBgDivTwo>
            </BookImgCol2>

          </BookImgsRow>

        </InternalContainer>
      </FluidContainer>
		);
	}
}

const HealthItemDiv = styled.div`
  h4, p {  }
`;

const SingleBookBgDiv = styled.div`
  padding: 20px 0 20px 50px;
  background-image: url(${book1}); 
  ${media.md` background-repeat: no-repeat; padding: 20px 170px 5px 50px; `}
  ${media.lg ` background-image: none; padding: 20px 0 0 50px; p { margin: 0 0 16px 0; } `}  
  ${media.xl ` padding: 20px 25px 20px 50px; `}
`;
const SingleBookBgDivTwo = styled.div`
  padding: 20px 0 20px 50px;
  background-image: url(${book1}); 
  ${media.md` background-repeat: no-repeat; padding: 20px 170px 5px 50px; `}
  ${media.lg ` background-image: none; padding: 20px 0 0 70px; p { margin: 0 0 16px 0; } `}  
  ${media.xl ` padding: 20px 100px 20px 0px; `}

  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;

  img {
    width: 80%;
    height: auto;
    max-height: 80%;
    margin: 0 auto;
    display: block;

  }
`;

const BookImgCol1 = styled(Col)`
  margin: 0 0 20px 0;
  ${media.lg ` margin: 0 `}  
`;
const BookImgCol2 = styled(Col)`
  display: none;
  margin: 0 0 20px 0;
  ${media.lg ` margin: 0; display: block; `}  
  ${media.xl` padding: 0 10px 0 10px!important; `}
`;

const BookImgsRow = styled(Row)`
  margin: 40px 0 0 0;
  h3 { padding: 0px 0 24px 0; margin: 0; }
  ${media.lg ` background-image: url(${bookAbove991});`}  
`;


const FluidContainer = styled(Container)` 
  padding: 30px 0 20px 0!important; 
  background-image: url(${nutritionBG}); 
`;
const InternalContainer = styled(Container)` h1 {color: black!important;} `;

//const Div_s = styled.div``;

/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
	display: ${a => a.listSelected ? "block" : "none"};
`;
*/



// WEBPACK FOOTER //
// ./src/pages/Storage.js